'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:WorkspacesCtrl
 * @description
 * # WorkspacesCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('WorkspacesCtrl', ['$scope', 'Workspace', 'Pagination', 'toaster', function ($scope, Workspace, Pagination, toaster) {

    const SEARCH_ATTRIBUTES = {
      'search': '',
      'by_column': '',
      'filters': {
        'id': 'fa-sort-asc',
        'name': 'fa-sort',
      }
    };
    $scope.search = SEARCH_ATTRIBUTES;

    $scope.currentPage = 1;

    $scope.workspaces = {
      list: [],
      pager: {}
    };

    $scope.getPage = function(page) {
      var params = {
        params: {
          page: page,
          per_page: 10,
          search: $scope.search.search,
          by_column: $scope.search.by_column
        }
      };

      $scope.currentPage = page;

      Workspace.index(params).then(function(response) {
        $scope.workspaces = response.data.workspaces
        $scope.workspaces.pager = Pagination.GetPager(
          response.data.meta.pagination.total_objects,
          page,
          response.data.meta.pagination.per_page);
        },function(error) {
          Workspace.error(error);
      });
    }

    $scope.clearSearch = function() {
      $scope.search = SEARCH_ATTRIBUTES;
      $scope.search.search = '';
      $scope.getPage(1);
    }

    $scope.pager = {};
    $scope.getPage(1);

    $scope.filter = function(column) {
      var order = '';
      angular.forEach($scope.search.filters, function(value, key) {
        if(column === key) {
          if($scope.search.filters[key] === 'fa-sort-desc') {
            $scope.search.filters[key] = 'fa-sort-asc';
            order = 'ASC';
          } else {
            $scope.search.filters[key] = 'fa-sort-desc';
            order = 'DESC';
          }
        } else {
          $scope.search.filters[key] = 'fa-sort';
        }
      });
      $scope.search.by_column = {
        column: column,
        order: order
      };
      $scope.getPage(1);
    };

    $scope.deleteWorkspace = function(workspace) {
      var index = $scope.workspaces.indexOf(workspace);
      Workspace.delete(workspace.id).then(function() {
        $scope.workspaces.splice(index, 1);
        toaster.pop('success', 'Workspace', 'Se elimino correctamente el workspace');
      }, function(error) {
        Workspace.error(error);
      });
    };

    $scope.toggleNotification = function(workspace) {
      Workspace.toggleNotification({ workspace }).then(function() {
        $scope.getPage($scope.currentPage);
        toaster.pop('success', 'Workspace', 'Se edito correctamente el workspace');
      }, function(error) {
        Workspace.error(error);
      });
    }
  }]);
